import React from "react";
import { Link } from "react-router-dom";
import { Image, Stack } from "react-bootstrap";
import Lottie from "lottie-react";
import { useTranslation } from "react-i18next";

import "./WelcomePage.scss";
import PrimaryActionButton from "../../../components/Buttons/PrimaryActionButton/PrimaryActionButton";
import ShieldAnimation from "../../../assets/animations/shield-with-hand.json";
import HyperTextIcon from "../../../images/group_hyper_word_icon.svg";
import { OnboardingSteps } from "../../../utils/constants";
import useOnboardingSteps from "../../../hooks/useOnboardingSteps";
import useAuth from "../../../hooks/useAuth";
import useAnalytics from "../../../hooks/useAnalytics";
import OnboardingContainer from "../../../components/onboarding/OnboardingContainer/OnboardingContainer";
import { capitalizeFirstLetter } from "../../../utils/helpers";

function WelcomePage() {
  const { t } = useTranslation("common");
  const { userProfile } = useAuth();
  const username = userProfile?.username;
  const { goToStep } = useOnboardingSteps();
  const analytics = useAnalytics();

  const handleContinue = () => {
    analytics.sendStartGamingEvent();
    goToStep(OnboardingSteps.VIEW_INSURANCE_BONUS);
  };

  return (
    <OnboardingContainer className="welcome-page">
      <div>
        <Link to="/">
          <Image className="sign-up-to-hyper-text-image" src={HyperTextIcon} />
        </Link>{" "}
      </div>

      <Stack className="align-items-center justify-content-end">
        <div className="image-gamepad-container">
          <Lottie
            animationData={ShieldAnimation}
            loop={false}
            className="game-pad-animation"
          />
        </div>
        <Stack gap={2} className="text-content">
          <h1 className="welcome-text">
            {t("onboarding.welcome_to_hyper")},
            <br /> {capitalizeFirstLetter(username ?? "")}!
          </h1>
          <h6 className="battle-text">
            {t(
              "onboarding.battle_with_friends_have_fun_and_start_winning_real_money"
            )}
            .
          </h6>
        </Stack>
        <PrimaryActionButton
          size="lg"
          text={`${t("lets_go")}!`}
          buttonClassName="lets-go-button"
          textClassName="lets-go-button-text"
          onClick={handleContinue}
        />
      </Stack>
    </OnboardingContainer>
  );
}

export default WelcomePage;
